export default [
  'period',
  'fromcurrency',
  'tocurrency',
  'openspotrate',
  'endspotrate',
  'monthlyoperatingrate',
  'weightedaveragerate',
  'fromcurrencyprecision',
  'tocurrencyprecision',
];
